/** Boundary tags marking untrusted external data inside prompts */
export const EXTERNAL_DATA_MARKERS = {
    START: '[EXTERNAL_DATA_START]',
    END: '[EXTERNAL_DATA_END]',
} as const

/**
 * inputUiInfo key the PANEL writes when a manual step test fails: the wizard
 * has no other way to know — a failed test persists no sample data, so the
 * server would only see "still untested" and ask for the test again.
 * Carries the formatted MESSAGE only, never the raw output: an HTTP step's
 * output echoes the request headers, credentials included.
 */
export const AI_BUILDER_LAST_TEST_ERROR = 'aiBuilderLastTestError'

/** Panel error messages are truncated before they are persisted or shown */
export const AI_BUILDER_TEST_ERROR_MAX_LENGTH = 500
